import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from './../../../core/services/authentication.service';
import { Router } from '@angular/router';
import { CommonNotificationService } from './../../../core/services/common-notification.service';
import Swal from 'sweetalert2';
import { catchError } from 'rxjs/internal/operators/catchError';
import { of } from 'rxjs/internal/observable/of';
import { tap } from 'rxjs/internal/operators/tap';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

  status = true;
  userName: string;
  isAuthenticated: boolean;
  webNotificationToken: any;

  constructor(
    private router: Router, private authenticationService: AuthenticationService, private commonNotificationService: CommonNotificationService
  ) { }

  ngOnInit(): void {
    this.userName = localStorage.getItem('name');
    this.pageHeader();
    this.commonNotificationService.getWebNotificationToken().subscribe((res) => {
      this.webNotificationToken = res;
    });
  }

  pageHeader() {
    if (window.location.href.includes('/pages')) {
      this.isAuthenticated = true;
    } else {
      this.isAuthenticated = false;
    }
  }

  toggleDropdownMenu() {
    this.status = !this.status;
  }

  signOut() {
    const authData = {
      deviceToken: this.webNotificationToken
    };
    Swal.fire({
      title: 'Are you sure you want to logout?',
      showCancelButton: true,
      confirmButtonText: `Yes`,
    }).then((result) => {
      if (result.isConfirmed) {
        this.authenticationService
          .logout(authData)
          .pipe(catchError(err => of(err)
          ), tap((resp: any) => {
            if (resp.status === 'success') {
              Swal.fire('Logged Out!', '', 'success');
              localStorage.clear();
              this.router.navigate(['../auth']);
            } else {
              Swal.fire({
                title: 'Something went wrong',
                width: 300,
                text: resp.error.error.message,
                icon: 'error',
              });
            }
          }),
          ).subscribe();
      }
    });
  }

  routeToChange() {
    this.router.navigate(['../auth/change-password']);
  }

  routeToPages() {
    this.router.navigate(['../pages/dashboard']);
  }

  onClickedOutside(e: Event) {
    if (this.status == false) {
      this.status = true;
    }
  }

}
